<template>
  <Header />
  <About />
  <Footer />
</template>

<script>
import Header from "@/components/Header.vue";
import About from "@/components/About.vue";
import Footer from "@/components/Footer.vue";

export default {
  components: {
    Header,
    About,
    Footer,
  },
};
</script>
